// add an ability to stub a module
import * as LDClient from 'launchdarkly-js-client-sdk';
export default LDClient;
